import { render, staticRenderFns } from "./ApplicationUploads.vue?vue&type=template&id=b9d6565c&"
import script from "./ApplicationUploads.vue?vue&type=script&lang=js&"
export * from "./ApplicationUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports